import { Field } from "./ticketingApi";
import { TicketStatus } from "./tickets";

export interface Filters {
  createdAfter: string;
  priority: string;
  product: string;
  scope: TicketHistoryScopeType;
  statusIs: string;
}

export enum PaginationNavigation {
  back = "back",
  forward = "forward",
  toPage = "toPage",
}

// Paste does not export this type so we need to duplicate it here
export type PasteBadgeVariants =
  | "info"
  | "default"
  | "warning"
  | "error"
  | "success"
  | "new";

export interface Ticket {
  id: number;
  subject: string;
  createdAt: string;
  updatedAt: string;
  status: TicketStatus;
  priority: string;
  product: Field;
}

export interface TicketHistoryViewProps {
  currentPage: number;
  emptyState?: TicketHistoryEmptyStateVariants;
  permissions?: TicketHistoryPermissions;
  loading?: boolean;
  loadingRowCount?: number;
  onApplyFilters: (filters: Filters) => void;
  onClearFilters: () => void;
  onSearch?: (query: string) => void;
  onPaginate: (page: number) => void;
  pageCount: number;
  priorityLevelFields?: Field[];
  productFields?: Field[];
  statusFields?: Field[];
  ticketDetailsRootUrl: string;
  tickets: Ticket[];
}

export interface TicketHistoryPermissions {
  canViewAccountLevelTicketHistory?: boolean;
}

export enum TicketHistoryEmptyStateVariants {
  noData = "noData",
  noResults = "noResults",
  initialLoadError = "initialLoadError",
  searchError = "searchError",
}

export interface TicketEmptyStateProps {
  variant: TicketHistoryEmptyStateVariants;
}

export interface TicketEmptyStateVariantCopy {
  heading: string;
  description: string;
}

export interface TicketFilterControlsProps {
  onApplyFilters: (filters: Filters) => void;
  onChangeFilters: (haveFiltersChanges: boolean) => void;
  onClearFilters: () => void;
  onSearch?: (query: string) => void;
  priorityLevelFields: Field[];
  productFields?: Field[];
  permissions: TicketHistoryPermissions;
  statusFields: Field[];
}

export interface TicketPaginationProps {
  currentPage: number;
  onPaginate: (page: number) => void;
  pageCount: number;
}

export interface TicketRowsSkeletonProps {
  loadingRowCount: number;
}

export interface TicketTableRowsProps {
  priorityLevelFields: Field[];
  tickets: Ticket[];
  ticketDetailsRootUrl: string;
}

export enum TicketHistoryScopeType {
  requester = "requester",
  account = "account",
}
